/* Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved. */

import { globalRef, type Unsubscribe } from '@amazon/vinyl-util'

const pageFocusOwnersRef = globalRef(() => ({ count: 0 }))

/**
 * Hands focus after a navigation to another owner (TV spatial navigation) until the
 * returned disposer runs, so the router stops moving it to the new page's heading.
 */
export function ownPageFocus(): Unsubscribe {
    const owners = pageFocusOwnersRef.value
    owners.count++
    return () => {
        owners.count--
    }
}

export function isPageFocusOwned(): boolean {
    return pageFocusOwnersRef.value.count > 0
}
